import { StatsInfo } from "schemas"
import { Container, Grid, styled, VStack } from "styled-system/jsx"

import Stat from "./Stat"

type Props = StatsInfo

function Columns({
  col1Number,
  col1Unit,
  col1UnitPosition,
  col1Text,
  col2Number,
  col2Unit,
  col2UnitPosition,
  col2Text,
  col3Number,
  col3Unit,
  col3UnitPosition,
  col3Text,
}: Props) {
  return (
    <styled.div
      className="statsInfo"
      css={{
        pt: "80px",
        pb: "80px",
        bgImage:
          "url(/stats-bg.svg), linear-gradient(91deg, #3625C1 -30.82%, #060086 100%)",
        backgroundPosition: "center",
        color: "white",
      }}>
      <Container>
        <VStack gap={10}>
          <Grid columns={{ lg: 3 }} columnGap="76px" rowGap={12}>
            <Stat
              number={col1Number}
              unit={col1Unit}
              position={col1UnitPosition}
              text={col1Text}
            />
            <Stat
              number={col2Number}
              unit={col2Unit}
              position={col2UnitPosition}
              text={col2Text}
            />
            <Stat
              number={col3Number}
              unit={col3Unit}
              position={col3UnitPosition}
              text={col3Text}
            />
          </Grid>
        </VStack>
      </Container>
    </styled.div>
  )
}

export default Columns
export type { Props as ColumnsProps }
